import * as React from 'react';
import { Collapsible, CollapsibleContent } from '../ui/collapsible';

export interface FilterDefinition {
  id: string;
  name: string;
  renderFilter: (props: {
    onClose: () => void;
    isOpen: boolean;
  }) => React.ReactNode;
  renderChip: () => React.ReactNode | null;
  isActive: () => boolean;
  onClear?: () => void;
}

export interface FilterBarProps {
  filters: FilterDefinition[];
  isExpanded: boolean;
  onClose: () => void;
}

export function FilterBar({ filters, isExpanded, onClose }: FilterBarProps) {
  return (
    <Collapsible open={isExpanded} onOpenChange={onClose}>
      <CollapsibleContent>
        <div className="tw:border-t tw:border-neutral-200 tw:pb-4" />
        <div className="tw:flex tw:flex-wrap tw:gap-2 tw:items-center">
          {filters.map((filter) => (
            <div key={filter.id} className="tw:flex tw:items-center">
              {filter.renderFilter({
                onClose,
                isOpen: isExpanded,
              })}
            </div>
          ))}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
